import {Component, Input, OnInit} from '@angular/core';
import {CommonModule, registerLocaleData} from "@angular/common";
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import localeNl from '@angular/common/locales/nl';

registerLocaleData(localeNl, 'nl');

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-pga-weekend',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-pga-weekend.component.html',
  styleUrl: './tekst-pga-weekend.component.scss',
})
export class TekstPgaWeekendComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();

  public bedragKm = 0;
  public bedragDag = 0;

  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
      if (this.year == 2024 || this.year == 2025 || this.year == 2026) {
        this.bedragKm = 0.23;
        this.bedragDag = 13
      }
    })
  }

}
